import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type InventoryProductPreparedEntityTableName =
    | 'inventory_products'
    | 'inventory_changes';

export type PreparedInventoryProductData = {
    record: Model;
    table: InventoryProductPreparedEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: InventoryProductPreparedEntityTableName,
    operation: ValidationOperation,
): PreparedInventoryProductData => ({
    record,
    table,
    operation,
});

export const mapRecords = (
    records: Model[],
    table: InventoryProductPreparedEntityTableName,
    operation: ValidationOperation,
): PreparedInventoryProductData[] =>
    records.map((record) => mapRecord(record, table, operation));

export const addPreparedDataBatch = async (
    preparedData: PreparedInventoryProductData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
